import { IdName } from "../../../utils/types";
import Autocomplete from "../../library/Autocomplete";

interface GroupByAutocompleteProps {
  id: string;  
  onChange: (selected: IdName[]) => void;
  options: IdName[];
  selected: IdName[];
  reactRef: any;
}

function GroupByAutocomplete(props: GroupByAutocompleteProps) {
  return (
    <Autocomplete
      id="groupByAutocomplete1"
      placeholder="Group by"
      reactKey="groupByAutocomplete1"
      labelKey="name"
      onChange={props.onChange}
      options={props.options}
      selected={props.selected}
      reactRef={props.reactRef}
      renderToken={true}
      keepDropdownOpen={true}
      multiple
    />
  );
}

export default GroupByAutocomplete;
